import $ from 'jquery';


$(document).scroll(function(event){
  if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
    $('#ArchSticky').addClass('drop');
  } else {
    $('#ArchSticky').removeClass('drop');
     
  }
});


$(document).scroll(function(event){
  if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 500) {
      $('#ArchIndexNav').addClass('drop');
      $('#IndexArchLogo').fadeIn();
      } else {
      $('#ArchIndexNav').removeClass('drop');
       $('#IndexArchLogo').fadeOut();
    }
});

  // var content = $('#archContent');
  // var triggered = false
  // $(document).scroll(function(event) {
  //   if (!triggered && content[0].getBoundingClientRect().top < 1600) {
      

  //     } else {
    
  //   }
  // });



//   window.onscroll = function() {
//   var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
//   if (scrollTop >= document.getElementById("archContent").offsetTop) {
//     $('#ArchSticky').addClass('drop');
//   } else {
//     $('#ArchSticky').removeClass('drop');
//   }
// }